import { render, staticRenderFns } from "./BacklogTarefaPage.vue?vue&type=template&id=37abd796"
import script from "./BacklogTarefaPage.vue?vue&type=script&lang=js"
export * from "./BacklogTarefaPage.vue?vue&type=script&lang=js"
import style0 from "./BacklogTarefaPage.vue?vue&type=style&index=0&id=37abd796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports